import script from "./TableWithPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableWithPreview.vue?vue&type=script&setup=true&lang=ts"

import "./TableWithPreview.vue?vue&type=style&index=0&id=7754d617&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7754d617"]])

export default __exports__